/** A 4xx answers the same every time; without `.status`, assume the network. */
export const retryTransient = (failureCount, error) =>
    (!error?.status || error.status >= 500) && failureCount < 2;

/**
 * Tried once, or never will be. An errored query has no `dataUpdatedAt`, so it
 * is always stale and drops back to `isLoading` on the refetches that recover
 * it; gating on `isLoading` would blank a settled answer every time.
 */
export const hasSettled = ({ isFetched, isIdle }) => isFetched || isIdle;
